module.exports = __webpack_public_path__ + "static/media/hero_banner_2img.2c702477.png";